export const EmployeeModalityTrainingCategoryFactory = () => {
    return function EmployeeModalityTrainingCategory() {

        this.id = null;
        this.name = null;
        this.orderNum = null;
    };
};
